module.exports = __webpack_public_path__ + "img/human-resources-search-men.f940b808.svg";